import { BlueBirdTheme, Button, Typography } from "@kitbird/core";
import { useUserPosition } from "../Provider";
import Modal from "../../../../components/Modal";

const ConfirmationModal = ({ onSubmit, loading }: {
    onSubmit: () => void
    loading?: boolean
}) => {
  const {
    modal,
    selectedRow,
    confirmationModal,
    setConfirmationModal,
  } = useUserPosition();

  const handleCancelModal = () => {
    setConfirmationModal(false);
  };

  const modalVariable = {
    CREATE: "Tambah",
    EDIT: "Edit",
  };

  return (
    <Modal
      title={`Konfirmasi ${(modal === "CREATE" || modal === "EDIT") && modalVariable[modal]} data`}
      isOpen={confirmationModal}
      setOpen={handleCancelModal}
      body={
        <Typography level={5} fontWeight="medium">
          {`Apakah anda yakin ingin  ${(modal === "CREATE" || modal === "EDIT") && modalVariable[modal]} data`}
          <Typography level={5} fontWeight="bold">
            &nbsp;{selectedRow?.employee_name} - {selectedRow?.employee_id}&nbsp;
          </Typography>
          user ?
        </Typography>
      }
      footer={
        <>
          <Button
            variant="text"
            type="button"
            onClick={() => handleCancelModal()}
          >
            Batal
          </Button>
          <Button
            disabled={loading}
            onClick={onSubmit}
          >
            {loading ? "loading..." : `Ya, ${(modal === "CREATE" || modal === "EDIT") && modalVariable[modal]}`}
          </Button>
        </>
      }
    />
  );
};

export default ConfirmationModal;
